<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-角色管理-添加
    -->
    <el-dialog
    title="添加角色"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="编码" prop="code">
        <el-input v-model="form.code" placeholder="请输入编码" class="max-w460"></el-input>
      </el-form-item>

      <!-- 添加入驻费用字段 -->
      <el-form-item label="入驻费用" prop="entry_fee">
        <el-input v-model="form.entry_fee" placeholder="请输入入驻费用" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>

      <!-- 添加期限字段 -->
      <el-form-item label="期限" prop="valid_days">
        <el-input v-model="form.valid_days" placeholder="请输入有效天数" class="max-w460">
          <template slot="append">天</template>
        </el-input>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-switch v-model="form.status" active-text="启用" inactive-text="禁用"></el-switch>
      </el-form-item>

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="主路径" prop="main_path">
        <el-input v-model="form.main_path" placeholder="请输入主路径" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="订单详情路径" prop="order_detail_path">
        <el-input v-model="form.order_detail_path" placeholder="请输入订单详情路径" class="max-w460"></el-input>
      </el-form-item>

      <!-- 添加图片上传字段 -->
      <el-form-item label="角色图标" prop="image">
        <div class="image-upload-wrapper">
          <div class="image-preview" v-if="form.image">
            <img :src="form.image" class="preview-image" />
            <div class="image-actions">
              <i class="el-icon-delete" @click="deleteImage('image')"></i>
            </div>
          </div>
          <div class="upload-placeholder" @click="openImageUpload('image')" v-else>
            <i class="el-icon-plus"></i>
            <div>上传图标</div>
          </div>
        </div>
      </el-form-item>

      <!-- 添加权益字段 -->
      <el-form-item label="权益说明" prop="benefits">
        <el-input
          type="textarea"
          :rows="4"
          v-model="form.benefits"
          placeholder="请输入角色权益说明，多条权益请用换行分隔"
          class="max-w460"
        ></el-input>
      </el-form-item>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 1 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import UroleApi from '@/api/urole.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    // 自定义验证规则 - 数字验证
    const validateNumber = (rule, value, callback) => {
      if (value && isNaN(value)) {
        callback(new Error('请输入有效的数字'));
      } else {
        callback();
      }
    };

    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name:"",
        code:"",
        entry_fee: "", // 入驻费用
        valid_days: "", // 有效天数
        status:1,
        main_path:"",
        order_detail_path:"",
        benefits: "", // 权益说明
        image: "", // 角色图标
        image_id: "" // 图片ID
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入角色管理名称', trigger: 'blur' }],
        entry_fee: [
          { validator: validateNumber, trigger: 'blur' }
        ],
        valid_days: [
          { validator: validateNumber, trigger: 'blur' }
        ]
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      currentUploadField: "", // 当前上传的字段

      roleList: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        type:"mobile"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    /* 打开图片上传 */
    openImageUpload(field) {
      this.currentUploadField = field;
      this.isProductUpload = true;
      this.code = 'image';
    },

    /* 删除图片 */
    deleteImage(field) {
      this.form[field] = "";
      this.form[field + '_id'] = "";
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      form.status = form.status?1:0;
      
      // 处理数字字段，确保提交的是数字类型
      if (form.entry_fee) form.entry_fee = Number(form.entry_fee);
      if (form.valid_days) form.valid_days = Number(form.valid_days);
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          UroleApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null && e.length > 0) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1].toLowerCase();
          imgExpt.forEach((imgExt) => {
            if (imgExt === ext) {
              prevent = true;
              return false;
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        // 根据当前上传的字段设置对应的数据
        if (this.currentUploadField === 'image') {
          this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
        }
      }
      
      this.isProductUpload = false;
      this.currentUploadField = "";
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 增加对话框宽度以适应新字段 */
.max-w460 {
  max-width: 460px;
}

/* 图片上传样式 */
.image-upload-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.image-preview {
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 4px;
  cursor: pointer;
}

.upload-placeholder {
  width: 100px;
  height: 100px;
  border: 1px dashed #ddd;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #999;
}

.upload-placeholder:hover {
  border-color: #409eff;
  color: #409eff;
}

.upload-placeholder i {
  font-size: 24px;
  margin-bottom: 8px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/urole/index/part/add.vue